// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__28BhQ","title":"Images90_title__3C6X9","images":"Images90_images__1D4-6"};